import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-data-privacy-modal',
  templateUrl: './data-privacy-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataPrivacyModalComponent implements OnInit {
  @Input() public privacyMessage: string;

  public i18n: { [key: string]: string };
  public isPolicyRead: boolean = false;
  public isPolicyAccepted: boolean = false;
  @ViewChild('dataPolicyReadCheckbox')
  public dataPolicyReadCheckbox: ElementRef;

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.i18n = this.translateService.instant([
      'DataPrivacyModalCtrl_AcceptContinue',
      'DataPrivacyModalCtrl_Header',
      'DataPrivacyModalCtrl_PolicyReviewLabel',
      'DataPrivacyModalCtrl_PolicyAcceptLabel',
    ]);
  }

  public allowPolicyAcception(): void {
    this.isPolicyRead = true;
  }

  public focusCheckBox(): void {
    this.dataPolicyReadCheckbox?.nativeElement.focus();
  }
}
